import { createContext, useContext } from "react";

/**
 * Two surfaces share the same pages: the customer portal (MagicAd, user login, /app) and the internal Lab (service key,
 * /lab, technical view). Pages read paths and mode from here instead of hard-coding routes.
 */
export const MODES = {
  customer: {
    mode: "customer",
    base: "/app",
    paths: { home: "/app", jobs: "/app/annonser", job: (id) => `/app/annonser/${id}`, account: "/app/konto" },
    technical: false,
  },
  lab: {
    mode: "lab",
    base: "/lab",
    paths: { home: "/lab", jobs: "/lab/jobs", job: (id) => `/lab/jobs/${id}`, settings: "/lab/settings", docs: "/lab/docs" },
    technical: true,
  },
};

export const ModeContext = createContext(MODES.customer);
export const useMode = () => useContext(ModeContext);
